import API from "./baseApi";

const getVendorData = (payload) => {
    if (payload && Object.keys(payload).length) {
        let query = "?";
        Object.keys(payload).map((x) => {
            if (payload[x] !== undefined && payload[x] !== null) {
                let value = payload[x];
                if (typeof value === "object") {
                    value = JSON.stringify(value);
                }
                query = query + `${x}=${value}&`;
            }
        });
        console.log(query,"queryqueryqueryquery")
        return API.get("/vendor_list/" + query, payload);
    } else {
        return API.get("/vendor_list/");
    }
};

const getVendorMappedData = (payload) => {
    return API.get(`/vendor_list/allMapData`, payload);
};

const getVendorFilterData = (payload) => {
    return API.get(`/vendor_list/allData`, payload);
};


const createVendor = (payload) => {
    return API.post("/vendor_list/", payload);
};

const createVendorMap = (payload) => {
    return API.post("/vendor_list/create_vendor_mapping", payload);
};

// const deleteSubServiceMapping = (payload) => {
//   return API.post(`services/subservices/deleteSubServiceMapping`, payload);
// };

export default {
    getVendorData,
    getVendorMappedData,
    getVendorFilterData,
    createVendor,
    createVendorMap
    //   deleteSubServiceMapping,
};
